import { makeAutoObservable } from 'mobx';
import { addToBasket, removeFromBasket, fetchBasket } from '../http/basketAPI';

export default class BasketStore {
    constructor() {
        this._devices = [];
        this._totalCount = 0;
        this._totalPrice = 0;
        this._loading = false;
        makeAutoObservable(this);
    }

    setDevices(devices) {
        this._devices = devices;
        this._totalCount = devices.reduce((sum, item) => sum + (item.quantity || 1), 0);
        this._totalPrice = devices.reduce((sum, item) => sum + item.price * (item.quantity || 1), 0);
    }

    setTotalCount(count) {
        this._totalCount = count;
    }

    setTotalPrice(price) {
        this._totalPrice = price;
    }

    setLoading(bool) {
        this._loading = bool;
    }

    async addDevice(device) {
        try {
            this.setLoading(true);
            await addToBasket(device.id);
            const existing = this._devices.find(item => item.id === device.id);
            if (existing) {
                existing.quantity += 1;
            } else {
                this._devices.push({ ...device, quantity: 1 });
            }
            this._totalCount += 1;
            this._totalPrice += device.price;
        } catch (error) {
            console.error('Ошибка добавления в корзину:', error);
        } finally {
            this.setLoading(false);
        }
    }

    async removeDevice(id) {
        try {
            this.setLoading(true);
            await removeFromBasket(id);
            const item = this._devices.find(item => item.id === id);
            if (item) {
                this._totalCount -= item.quantity || 1;
                this._totalPrice -= item.price * (item.quantity || 1);
            }
            this._devices = this._devices.filter(item => item.id !== id);
        } catch (error) {
            console.error('Ошибка удаления из корзины:', error);
        } finally {
            this.setLoading(false);
        }
    }

    async loadBasket() {
        try {
            this.setLoading(true);
            const data = await fetchBasket();
            this.setDevices(data.devices || []);
        } catch (error) {
            console.error('Ошибка загрузки корзины:', error);
        } finally {
            this.setLoading(false);
        }
    }

    clearBasket() {
        this._devices = [];
        this._totalCount = 0;
        this._totalPrice = 0;
    }

    get devices() {
        return this._devices;
    }

    get totalCount() {
        return this._totalCount;
    }

    get totalPrice() {
        return this._totalPrice;
    }

    get loading() {
        return this._loading;
    }
}
